import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "manipulation-area py-2 pl-3 pr-0" }
const _hoisted_3 = {
  key: 0,
  class: "ai-texter-table mt-2"
}
const _hoisted_4 = { class: "ai-texter-table-header" }
const _hoisted_5 = { class: "ai-texter-table-col options-column pr-0" }
const _hoisted_6 = { class: "pl-2" }
const _hoisted_7 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_8 = { class: "ai-texter-table-col mid-col pl-0" }
const _hoisted_9 = { class: "pl-2" }
const _hoisted_10 = {
  key: 0,
  class: "ai-texter-table-overflow-container",
  "data-cy": "ai-texter-master-data-table"
}
const _hoisted_11 = { class: "ai-texter-table-row-container" }
const _hoisted_12 = { class: "ai-texter-table-row-data" }
const _hoisted_13 = ["data-cy"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pl-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["data-cy"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }

import Alert from "@common/components/Alert.vue";
import CommonFilter from "@common/components/CommonFilter.vue";
import Icon from "@common/components/Icon.vue";
import { AiTexterTypes } from "@medapro-types/ContentEditor/Components/AiTexter";
import _ from "lodash";
import { computed, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
type ViewModel = {
  selectedMasterData: AiTexterTypes.MasterDataItemForSelection[];
  sortByDesc: boolean | null;
  selectAll: boolean;
  searchTerm: string;
  inputIsFocused: boolean;
  firstMount: boolean;
  masterDataItems: AiTexterTypes.MasterDataItemForSelection[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'MasterDataMultiSelectList',
  props: {
    items: {}
  },
  emits: ["update:selectedItems"],
  setup(__props: any, { emit: emits }) {

const props = __props;


const { t: $t } = useI18n();

//#region General

//#endregion

const mdi = [];
if (props.items.name) {
  mdi.push({ name: $t("AiTexter.Name"), value: props.items.name, selected: true });
}
if (props.items.description) {
  mdi.push({ name: $t("AiTexter.Description"), value: props.items.description, selected: false });
}
if (props.items.attributeGroupPath) {
  mdi.push({ name: $t("AiTexter.attributeGroupPath"), value: props.items.attributeGroupPath, selected: false });
}
if (props.items.variationGroupName) {
  mdi.push({ name: $t("AiTexter.variationGroupName"), value: props.items.variationGroupName, selected: true });
}
if (props.items.catalogGroupPath) {
  mdi.push({ name: $t("AiTexter.CatalogGroupPath"), value: props.items.catalogGroupPath, selected: false });
}

const viewModel = reactive<ViewModel>({
  selectedMasterData: [],
  sortByDesc: null,
  selectAll: false,
  searchTerm: "",
  inputIsFocused: false,
  firstMount: false,
  masterDataItems: mdi
});

const sortedList = computed(() => {
  const filter = viewModel.searchTerm ? viewModel.searchTerm.toLowerCase() : null;
  const source = !filter
    ? viewModel.masterDataItems
    : _.filter(viewModel.masterDataItems, (x) => _.includes(x.name.toLowerCase(), viewModel.searchTerm.toLowerCase()));
  if (viewModel.sortByDesc === null) {
    return source;
  } else {
    return _.orderBy(source, "name", viewModel.sortByDesc ? "desc" : "asc");
  }
});

const setSortBy = () => {
  if (viewModel.sortByDesc === null) {
    viewModel.sortByDesc = true;
  } else {
    viewModel.sortByDesc = !viewModel.sortByDesc;
  }
};

const toggleSelectAll = () => {
  const isSelected = viewModel.selectAll;
  sortedList.value.forEach((item: any) => (item.selected = isSelected));
  viewModel.selectedMasterData = viewModel.selectAll ? [...sortedList.value] : [];
  emits("update:selectedItems", viewModel.selectedMasterData);
};

const isIndeterminate = computed(() => {
  return viewModel.selectedMasterData.length > 0 && viewModel.selectedMasterData.length < sortedList.value.length;
});

const handleCheckboxChange = (checked: boolean, selectedSortedItem: AiTexterTypes.MasterDataItemForSelection) => {
  if (checked) {
    viewModel.selectedMasterData.push(selectedSortedItem);
  } else {
    viewModel.selectedMasterData = viewModel.selectedMasterData.filter((item) => item.name !== selectedSortedItem.name);
  }
  const selectedCount = sortedList.value.filter((item) => item.selected).length;
  viewModel.selectAll = selectedCount === sortedList.value.length;
  emits("update:selectedItems", viewModel.selectedMasterData);
};

onMounted(() => {
  if (props.items.name) {
    viewModel.selectedMasterData.push({ name: $t("AiTexter.Name"), value: props.items.name });
  }
  if (props.items.variationGroupName) {
    viewModel.selectedMasterData.push({ name: $t("AiTexter.variationGroupName"), value: props.items.variationGroupName });
  }
  emits("update:selectedItems", viewModel.selectedMasterData);
});

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { class: "ai-texter-search" }, {
            default: _withCtx(() => [
              _createVNode(CommonFilter, {
                modelValue: viewModel.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.searchTerm) = $event)),
                placeholder: _unref($t)('AiTexter.FilterByName'),
                "prepend-icon": "Filter",
                "trigger-by-time": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (viewModel.masterDataItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_b_checkbox, {
                modelValue: viewModel.selectAll,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((viewModel.selectAll) = $event)),
                onChange: toggleSelectAll,
                indeterminate: isIndeterminate.value
              }, null, 8, ["modelValue", "indeterminate"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["ai-texter-table-col name-col pl-0", { 'sorted-by': viewModel.sortByDesc !== null }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setSortBy()))
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref($t)("AiTexter.Name")), 1),
              (viewModel.sortByDesc !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(Icon, {
                      icon: viewModel.sortByDesc ? 'ChevronBottom' : 'ChevronTop',
                      class: "font-weight-bolder"
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)("AiTexter.Value")), 1)
            ])
          ]),
          (sortedList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedList.value, (sortedItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: sortedItem.name,
                    class: "ai-texter-table-row"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: "ai-texter-table-col options-column pr-0",
                          "data-cy": 'masterDataCheckbox' + index
                        }, [
                          _createVNode(_component_b_checkbox, {
                            modelValue: sortedItem.selected,
                            "onUpdate:modelValue": ($event: any) => ((sortedItem.selected) = $event),
                            onInput: ($event: any) => (handleCheckboxChange($event, sortedItem))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                        ], 8, _hoisted_13),
                        _withDirectives((_openBlock(), _createElementBlock("div", {
                          class: "ai-texter-table-col name-col pl-0",
                          onClick: ($event: any) => (sortedItem.selected = !sortedItem.selected)
                        }, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(sortedItem.name), 1)
                        ], 8, _hoisted_14)), [
                          [_directive_tooltip, sortedItem.name]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", {
                          class: "ai-texter-table-col mid-col pl-0",
                          onClick: ($event: any) => (sortedItem.selected = !sortedItem.selected)
                        }, [
                          _createElementVNode("span", {
                            class: "pl-2",
                            "data-cy": 'ai-texter-master-data-name-' + index
                          }, _toDisplayString(sortedItem.value), 9, _hoisted_17)
                        ], 8, _hoisted_16)), [
                          [_directive_tooltip, sortedItem.value]
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(Alert, {
                  "with-icon": "",
                  show: "",
                  variant: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("AiTexter.NofilteredMasterData")), 1)
                  ]),
                  _: 1
                })
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(Alert, {
            "with-icon": "",
            show: "",
            variant: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("AiTexter.NoMasterdataAvailable")), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})